import React, { useEffect, useState } from 'react';
import DGVIcon from '../../assets/images/DGVIcon.png';
import LinkeDin from '../../assets/images/linkedin 1.svg';
import twitter from '../../assets/images/twitter 1.svg';
import youTube from '../../assets/images/Combined-Shape.svg';
import FaceBook from '../../assets/images/facebook.svg';
import Instagram from '../../assets/images/insta.svg';
import PCI from '../../assets/images/PCI.png';
import { FooterData } from '../../utils/constants';
import privacyPolicyDgv from '../../assets/documents/DgvPrivacyPolicy.pdf';
import privacyPolicyLending from '../../assets/documents/PrivacyPolicyLending.pdf';
import termsConditions from '../../assets/documents/TermsCondition.pdf';
// import dlgSets from '../../assets/documents/DLGSetsSept.pdf';
import { useNavigate, Link } from 'react-router-dom';
import '../Footer/Footer.css';
import { BASE_URL } from '../../utils/api';

const Footer = () => {
  let navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const onMenuClick = (listItem) => {
    if (listItem.linkTo) {
      navigate(listItem.linkTo);
      document.getElementById('hamburgerChk').checked = false;
    }
  };

  const onSubMenuClick = (event, listItem) => {
    event.stopPropagation();
    if (listItem.title === 'Privacy Policy') {
      window.open(privacyPolicyDgv);
    } else if (listItem.title === 'Privacy Policy Lending') {
      window.open(privacyPolicyLending);
    } else if (listItem.title === 'Terms & Conditions') {
      window.open(termsConditions);
    } else if (listItem.title === 'DLG Sets') {
      fetchData();
    } else {
      navigate(listItem.linkTo);
    }
  };

  const fetchData = async () => {
    try {
      const formData = new FormData();
      formData.append('docCode', 'DLG_SET');

      const response = await fetch(`${BASE_URL}getDocument`, {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();

      if (result.status === '0') {
        window.open(result?.data);
      } else {
        console.log('error');
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  return (
    <>
      <div className="footer">
        <div className="footer-wrap">
          <section className="footer-container socialMedia">
            <div className="footer-col-logo socialMedia ">
              <div className="dgvIcon">
                <img className="redImg" src={DGVIcon} alt="img" />
              </div>
              <div className="footer-subtitles ">
                India's First Integrated Dairy FinTech,<br></br> InsurTech & Marketplace Platform
              </div>
              <div className="socialMedia">
                <a
                  href="https://www.instagram.com/digi.vriddhi/"
                  className="social-icon mr-1"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={Instagram} alt="Instagram" />
                </a>
                <a
                  href="https://www.linkedin.com/company/neobharatbanking/?originalSubdomain=in"
                  className="social-icon mr-1"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={LinkeDin} alt="Linked in" />
                </a>

                <a href="https://twitter.com/dgvwings" target="_blank" rel="noreferrer" className="social-icon mr-1">
                  <img src={twitter} alt="Twitter" />
                </a>

                <a
                  href="https://www.youtube.com/channel/UC8--WZaJ9ZxSh9C-jU8zifw"
                  className="social-icon mr-1"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={youTube} alt="YouTube" />
                </a>
                <a
                  href="https://www.facebook.com/Digivriddhi/"
                  className="social-icon mr-1"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={FaceBook} alt="FaceBook" />
                </a>
              </div>
              {/* <div className="PCI">
                <img src={PCI} alt="PCI" />
              </div> */}
            </div>
            <div className="footer-col-wrapper">
              {FooterData.map((footerLink) => (
                <div className="footer-col" key={footerLink.id}>
                  <div
                    className="footer-link-our-network"
                    onClick={() => onMenuClick(footerLink)}
                    style={{ cursor: 'pointer' }}
                  >
                    <h4 className="footer-head">{footerLink.title}</h4>
                  </div>
                  <ul className="list" style={{ cursor: 'pointer' }}>
                    {footerLink?.subItems?.map((link, index) => {
                      return (
                        <div key={link.id}>
                          <Link to={link?.linkTo}>
                            <li className={link.class} onClick={(event) => onSubMenuClick(event, link)}>
                              {link.title}
                            </li>
                          </Link>
                        </div>
                      );
                    })}
                  </ul>
                </div>
              ))}
            </div>
          </section>
          <div className="copyright">
            <p className="allRights">Copyright © Digivriddhi Technologies Private Limited {currentYear}</p>
            <p className="allRights"> All Rights Reserved.</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
